/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import { Flex } from "..";
import { Label } from "../Label";
import { Radio } from "./Radio";
import { RadioHelperText } from "./Radio.helperText";
import { RadioLabel } from "./Radio.label";
import type { RadioSetProps } from "./Radio.types";
import { RadioGroup } from "./RadioGroup";

const RadioSet = ({ children, sx }: RadioSetProps) => {
  return (
    <Flex.Column
      sx={{
        '&:has([data-radio-icon_position="left"]) [data-radio-helper_text]': {
          paddingInlineStart: vars.spacing[6],
        },
        "&:has(input:disabled) [data-radio-helper_text]": {
          color: vars.semantic.color.textDisabled,
        },
        "& [data-radio-helper_text]": {
          color: vars.semantic.color.textSecondary,
        },
        ...sx,
      }}
    >
      {children}
    </Flex.Column>
  );
};

const RadioNamespace = Object.assign(Radio, {
  Set: RadioSet,
  Group: RadioGroup,
  Label: RadioLabel,
  HelperText: RadioHelperText,
  Legend: Label,
});

export { RadioNamespace as Radio };
